module.exports = __webpack_public_path__ + "img/77.9.TU.62259668.png";